import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-38f43dfa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "campaigns-table-loader" };
import BaseLoaderSpinner from '@/components/_atoms/BaseLoaderSpinner.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignsDynamicTableSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(BaseLoaderSpinner)
            ]));
        };
    }
});
